import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// project-imports
import SEO from '../../../common/SEO';
import Layout from '../../../common/Layout';
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne';
import InterviewSeriesOne from './InterviewSeriesOne';
import InterviewSeriesStencil from '../stencils/InterviewSeriesStencil';
import { GoogleAnalyticsEnum, pageView } from '../../../utils/google-analytics';
import { useInterviewContext } from '../../../context/interview_context';
import Spinner from '../../../components/spinner-component/SpinnerOne';
import ErrorComponent from '../../error-message/ErrorComponent';

const InterviewSeries = () => {

    // Extracting variables from context
    const { interviewCategories, interviewSeries, isLoading, isError } = useInterviewContext();

    // property initialization
    const { slug } = useParams();

    // Constant variable
    const isPublished = interviewSeries?.filter(i => i?.published === true);
    const data = isPublished?.filter(item => item?.categoryId === slug);

    // get Current Category
    const cateories = interviewCategories && interviewCategories?.length ? interviewCategories : [];
    const currentCategory = cateories?.filter((i) => i?.slug === slug);
    const currentCategoryName = currentCategory?.map((i) => i?.name);

    if (isLoading) {
        return (
            <div>
                <Spinner />
            </div>
        );
    }

    if (isLoading) {
        // Loading stencil
        return <InterviewSeriesStencil data={data} />
    }

    return (
        <>
            <SEO title={`${currentCategoryName} | Interview Q&A Series | Longswitch Academy`} /> {/* Set SEO title */}
            {pageView(window.location.pathname, GoogleAnalyticsEnum.INTERVIEW_QUESTIONS_SERIES)}
            <Layout>
                <BreadcrumbOne
                    title={currentCategoryName || ""} // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Interview Q&A Series"
                />
                {isPublished &&
                    <div className="edu-elements-area edu-section-gap bg-color-white">
                        <div className="container mb--80">
                            <div className="row g-5">
                                <div className="col-12">
                                    <div className="row y-gap-30 g-5">
                                        {!isLoading && isError ? (
                                            <div className="col-12 text-center">
                                                <ErrorComponent
                                                    errorCode="500"
                                                    mainError="No Interview Q&A Series are available!"
                                                    subText="Currently we don't have Interview Q&A Series. Please be back later."
                                                    buttonText="Back to Home"
                                                    link="/"
                                                />
                                            </div>

                                        ) : !isLoading && !isError && !data?.length ? (
                                            <div className="col-12 text-center">
                                                <ErrorComponent
                                                    errorCode="404"
                                                    mainError="Failed to get the Interview Q&A Series right now."
                                                    subText="Please return to the site's homepage, It looks like nothing was found at this location"
                                                    buttonText="Back to Home"
                                                    link="/"
                                                />
                                            </div>
                                        ) : (
                                            <>
                                                {
                                                    (data || [])?.map((item) => (
                                                        <div className="col-lg-4 col-md-6 col-12" key={item.id}>
                                                            {/* Render individual post */}
                                                            <InterviewSeriesOne data={item} bgGray="enable" />
                                                        </div>
                                                    ))
                                                }
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </Layout>
        </>
    )
}

export default InterviewSeries;